import { Component } from '@angular/core';
import { CurrentSelectionDisplay } from '../../../models/current-selection-display';
import { FilterDrawerToggleComponent } from '../filter-drawer-toggle/filter-drawer-toggle.component';
import { FilterCurrentSelectionsDisplayComponent } from '../filter-current-selections-display/filter-current-selections-display.component';
import { FilterChipOverflowComponent } from '../filter-chip-overflow/filter-chip-overflow.component';

@Component({
  selector: 'app-filter-toggle-current-selections-container',
  templateUrl: './filter-toggle-current-selections-container.component.html',
  styleUrls: ['./filter-toggle-current-selections-container.component.scss'],
  standalone: true,
  imports: [
    FilterDrawerToggleComponent,
    FilterCurrentSelectionsDisplayComponent,
    FilterChipOverflowComponent,
  ]
})
export class FilterToggleCurrentSelectionsContainerComponent {
  overflowingCurrentSelections: CurrentSelectionDisplay[] = [];
}
